import { startCase } from 'lodash-es'
import { useFilters, usePinnedFilters } from '../../model'
import { StatusFilter } from '../filters/items/status-filter'
import { FilterChip } from './filter-chip'

interface FilterChipsProps {
  mode: 'pinned' | 'unpinned'
}

export function FilterChips({ mode }: FilterChipsProps) {
  const { filters, setFilters, disabledFilters } = useFilters()
  const { pinnedFilters } = usePinnedFilters()

  return (
    <>
      <FilterChip
        filterKey="status"
        label="Status"
        hasValue={filters.status.length > 0}
        onClose={() => setFilters({ status: [] })}
        dropdownContent={<StatusFilter />}
        pinned={pinnedFilters.includes('status')}
        mode={mode}
        disabled={!!disabledFilters.status}
        disabledTooltip={disabledFilters.status}
      >
        {filters.status[0] === 'awaiting'
          ? 'Awaiting / In Progress'
          : filters.status[0] === 'auto_reviewed'
            ? 'Auto Approved'
            : startCase(filters.status[0])}
      </FilterChip>
    </>
  )
}
